export interface ExcelExport {
    mapping: {
        colCode: string;
        colName: string;
    }[];
    data: any[];
}
